module.exports = __webpack_public_path__ + "img/edamame.8c629bde.png";